import DefaultLayout from "../layouts/DefaultLayout";
import SortableDataTable from "../components/SortableDataTable";
import {useCallback, useEffect, useMemo, useState} from "react";
import ConfirmationModal from "./modals/ConfirmationModal";
import useTranslation from "../hooks/translations";
import IncomeTypeModal from "./modals/IncomeTypeModal";
import {TrendingUp} from "react-feather";
import {useApi} from "../contexts/ApiProvider";
import IncomeTypeService from "../services/IncomeTypeService";
import ProtectedContent from "../components/ProtectedContent";

export default function IncomeTypeSettingsPage() {
  const translations = useTranslation();
  const columns = [
    {
      name: translations.name,
      data_identifier: "name"
    },
    {
      name: translations.description,
      data_identifier: "description"
    },
    {
      name: translations.calculateForGross,
      data_identifier: "calculateForGrossFormatted"
    },
    {
      name: translations.calculateForNet1,
      data_identifier: "calculateForNet1Formatted"
    },
    {
      name: translations.calculateForNet2,
      data_identifier: "calculateForNet2Formatted"
    }
  ];
  const pageTitle = translations.incomeType
  const pageSubtitle = translations.incomeTypePageSubtitle
  const api = useApi()
  const incomeTypeService = useMemo(() => new IncomeTypeService(api), [api]);

  const [openIncomeTypeModal, setOpenIncomeTypeModal] = useState(false);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [rows, setRows] = useState([]);

  const getData = useCallback(async () => {
    const response = await incomeTypeService.getAll();
    const formatedResponse = response.body.map((row) => {
      return {
        id: row.id,
        name: row.name,
        description: row.description,
        order: row.order,
        calculateForGross: row.calculate_for_gross,
        calculateForGrossFormatted: row.calculate_for_gross ? translations.yes : translations.no,
        calculateForNet1: row.calculate_for_net_1,
        calculateForNet1Formatted: row.calculate_for_net_1 ? translations.yes : translations.no,
        calculateForNet2: row.calculate_for_net_2,
        calculateForNet2Formatted: row.calculate_for_net_2 ? translations.yes : translations.no,
      }
    });
    setRows(formatedResponse);
  }, [incomeTypeService, translations.yes, translations.no])

  const reorderData = useCallback(async (data) => {
    const formatedRequest = data.map((row) => {
      return {
        id: row.id,
        order: data.indexOf(row) + 1
      }
    });
    await incomeTypeService.reorder(formatedRequest);
  }, [incomeTypeService])

  useEffect(() => {
    (async () => {
      await getData()
    })();
  }, [getData]);

  // datatable callbacks
  const onEditClick = async (data) => {
    setSelectedRow(data)
    setOpenIncomeTypeModal(true)
  }

  const onDeleteClick = async (data) => {
    setSelectedRow(data)
    setOpenConfirmationModal(true)
  }

  const onAddClick = async () => {
    setOpenIncomeTypeModal(true)
    setSelectedRow({})
  }

  const handleDragEnd = async (data) => {
    setRows(data)
    await reorderData(data)
  }

  // income type modal callbacks
  const onModalSubmit = async (data) => {
    await getData()
    setOpenIncomeTypeModal(false)
  }

  const onModalClose = async () => {
    setOpenIncomeTypeModal(false)
  }

  // confirmation modal callbacks
  const onConfirmationModalSubmit = async (data) => {
    await incomeTypeService.delete(data.id)
    await getData()
    setOpenConfirmationModal(false)
  }

  const onConfirmationModalClose = async () => {
    setOpenConfirmationModal(false)
  }

  return (
    <DefaultLayout icon={<TrendingUp/>}
                   title={pageTitle}
                   subtitle={pageSubtitle}>
      <ProtectedContent
        allowedRoles={["Admin"]}
        alt={<div style={{textAlign: "center", margin: 10}}>
          <h1>{translations.permissionsAlert}</h1></div>}>
        <SortableDataTable title={pageTitle}
                           columns={columns}
                           rows={rows}
                           editAction={onEditClick}
                           deleteAction={onDeleteClick}
                           addAction={onAddClick}
                           dragEndAction={handleDragEnd}/>
        {openIncomeTypeModal &&
          <IncomeTypeModal data={selectedRow}
                           title={pageTitle}
                           onModalSubmit={onModalSubmit}
                           onModalClose={onModalClose}
                           showModal={openIncomeTypeModal}/>
        }
        {openConfirmationModal &&
          <ConfirmationModal data={selectedRow}
                             onConfirmationModalSubmit={onConfirmationModalSubmit}
                             onConfirmationModalClose={onConfirmationModalClose}
                             showModal={openConfirmationModal}/>
        }
      </ProtectedContent>
    </DefaultLayout>
  )
}
